import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {TRAFFIC_LIGHTS} from "../../util/RouteConstants";
import TrafficLightDeviceOverviewContextProvider from "./context/TrafficLightOverviewContext";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class TrafficLightPage extends Component {
    render() {
        return (
            <Column>
                <TrafficLightDeviceOverviewContextProvider>
                    <TabLayout routes={TRAFFIC_LIGHTS} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={TRAFFIC_LIGHTS}/>
                </TrafficLightDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default TrafficLightPage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/TrafficLightPage.js